export const LONG_FORM_DRAFT_STATUS = {
  draft: 'long_form_draft',
  editing: 'long_form_editing',
  archived: 'long_form_archived',
};

export const LONG_FORM_CONTINUE_MODE = {
  fromEmpty: 'from_empty',
  continue: 'continue',
  insertion: 'insertion',
};

export const prepareContinueModeForBackend = (mode) => {
  // `fromEmpty` is FE-only value, so we should not send it to the backend
  if (mode === LONG_FORM_CONTINUE_MODE.fromEmpty) {
    return null;
  }

  return mode;
};

export const LONG_FORM_ORIGINAL_DRAFT_INDEX = '0';
